import React from 'react'
import { trackError, flushUsage } from '../services/usage'

/** Catches React render crashes, records them and shows a recoverable screen. */
class ErrorBoundary extends React.Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    trackError('ui.crash', error && error.message, error && error.stack, {
      componentStack: info && info.componentStack ? String(info.componentStack).slice(0, 600) : undefined
    })
    flushUsage()
  }

  render() {
    if (!this.state.hasError) return this.props.children
    return (
      <div style={{ padding: '120px 20px 60px', textAlign: 'center', fontFamily: 'Arsenal, sans-serif' }}>
        <h3>Щось пішло не так</h3>
        <p>Ми вже записали цю помилку. Спробуйте оновити сторінку.</p>
        <button
          type='button'
          onClick={() => window.location.reload()}
          style={{ padding: '8px 18px', border: 'none', borderRadius: 8, background: '#b8d23d', color: '#fff', cursor: 'pointer' }}
        >
          Оновити
        </button>
      </div>
    )
  }
}

export default ErrorBoundary
